export default __webpack_public_path__ + "static/media/linkedin.7defd339.svg";